import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Products from "./pages/Products";
import Footer from "./components/Footer";

// Pages
import About from "./pages/About";
import Contact from "./pages/Contact";
import EssentialOils from "./pages/EssentialOils";
import CarrierOils from "./pages/CarrierOils";
import LiquidExtracts from "./pages/LiquidExtracts";
import SpiceOils from "./pages/SpiceOils";
import Butters from "./pages/NaturalButters";
import FloralWaters from "./pages/FloralWaters";
import Homepage from "./pages/Homepage";
import Certifications from "./pages/Certifications";
import LogisticsTesting from "./pages/LogisticsTesting";
import SourcingOils from "./pages/SourcingOils";
import PageLoader from "./components/PageLoader";
import Ayurveda from "./components/Blogs/Ayurveda";
import Cosmetics from "./components/Blogs/Cosmetics";
import Neutraceuticals from "./components/Blogs/Neutraceuticals";
import PersonalCare from "./components/Blogs/PersonalCare";
import Herbaceuticals from "./components/Blogs/Herbaceuticals";
import FoodBeverages from "./components/Blogs/FoodBeverages";
import TermsConditions from "./pages/TermsConditions";

const RouteChangeLoader = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    document.body.style.overflow = 'hidden';

    // Scroll to top without animation
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });

    // Hide loader after 1s
    const timer = setTimeout(() => {
      setLoading(false);
      document.body.style.overflow = '';
    }, 1000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <PageLoader loading={loading} />
      <div
        className={`transition-opacity duration-500 ${
          loading ? "opacity-0" : "opacity-100"
        }`}
      >
        {children}
      </div>
    </>
  );
};

const App = () => {

  return (
    <Router>
      <RouteChangeLoader>
        <Header />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/logistic_support" element={<LogisticsTesting />} />
          <Route path="/testing_facilities" element={<LogisticsTesting />} />
          <Route path="/sourcing" element={<SourcingOils />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/products" element={<Products />} />
          <Route path="/essential_oils" element={<EssentialOils />} />
          <Route path="/carrier_oils" element={<CarrierOils />} />
          <Route path="/liquid_extracts" element={<LiquidExtracts />} />
          <Route path="/spice_oils" element={<SpiceOils />} />
          <Route path="/spice_oils" element={<SpiceOils />} />
          <Route path="/natural_butters" element={<Butters />} />
          <Route path="/floral_waters" element={<FloralWaters />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="blog/ayurveda" element={<Ayurveda />} />
          <Route path="blog/cosmetics" element={<Cosmetics />} />
          <Route path="blog/neutraceuticals" element={<Neutraceuticals />} />
          <Route path="blog/personal_care" element={<PersonalCare />} />
          <Route path="blog/herbaceuticals" element={<Herbaceuticals />} />
          <Route path="blog/food_beverages" element={<FoodBeverages />} />
          <Route path="/tnc" element={<TermsConditions />} />
        </Routes>
        <Footer />
      </RouteChangeLoader>
    </Router>
  );
};

export default App;
